const autocompleteModalFilterExpiredServices = {
  site: 'Sites',
  equipments: 'Equipment Type',
  equipmentGroups: 'Equipment Group',
  place: 'Local',
  area: 'Departments',
  serviceTypes: 'Service Type',
  companies: 'Third party company',
  frequencies: 'Frequency',
  
};

export default autocompleteModalFilterExpiredServices;
